<script lang="ts">
	export let text: string
	export let width: number
</script>

<div class="col-span-12 md:col-span-{width} text">
	<div class="text-cont max-w-4xl">{@html text}</div>
</div>
